import React from 'react';
import { FiCheck } from 'react-icons/fi';
import './price-block.scss';



const TIERS = [
    {
        key: 'starter',
        name: 'Starter',
        price: '$350 CAD',
        tagline:
            'Designed for: Individuals beginning their trading journey and exploring market opportunities',
        features: [
            'Access to major CFD instruments (foreign exchange, commodities, and leading indices)',
            'Standard execution conditions and pricing environment',
            'Leverage up to 1:100',
            'Access to essential market data and charting tools',
            'Educational materials and platform guides',
            'Customer support via email during business hours',
        ],
        ctaHref: 'https://market.freedom7-24.com/',
    },
    {
        key: 'pro',
        name: 'Pro',
        price: '$2,500 CAD',
        tagline:
            'Designed for: Traders ready to engage more actively and broaden their market exposure',
        features: [
            'All Basic features, plus:',
            'Access to additional instruments, including minor FX pairs, precious metals, and selected equities',
            'Leverage up to 1:200',
            'Expanded analytics dashboard with performance metrics and portfolio overview',
            'Monthly account summary and consultation with a platform specialist',
            'Priority client support with faster response times',
        ],
        ctaHref: 'https://market.freedom7-24.com/',
    },
    {
        key: 'mega',
        name: 'Mega',
        price: '$10,000 CAD',
        tagline:
            'Designed for: Experienced traders seeking enhanced tools and personalized guidance',
        features: [
            'All Basic features, plus:',
            'Broader market access covering energy products and global indices',
            'Enhanced market-data access and technical-analysis suite',
            'Private Investment Advisor support for tailored portfolio insights and strategy discussion',
            'Dedicated account manager',
            'Invitations to educational webinars and professional commentary sessions',
        ],
        ctaHref: 'https://market.freedom7-24.com/',
    },
    {
        key: 'platinum',
        name: 'Platinum',
        price: '$50,000 CAD',
        tagline:
            'Designed for: Professional-level clients seeking comprehensive market access and personalized service',
        features: [
            'All Basic features, plus:',
            'Full access to global CFD markets including equities, commodities, indices, and digital assets (where available)',
            'Leverage up to 1:100',
            'Private Investment Advisor support for tailored portfolio insights and strategy discussion',
            'Dedicated account manager',
            'Customized reporting suite and trade data exports',
            'Priority access to account and technical specialists',
            'Ongoing consultation with a Private Investment Advisor for portfolio monitoring and market updates',
            'Exclusive access to advanced tools, research briefings, and invitation-only programs',
        ],
        ctaHref: 'https://market.freedom7-24.com/',
        featured: true,
    },
];

export default function PriceBlock() {
    return (
        <section id="price" className="price-block">
            <div className="price-block__bg" aria-hidden />
            <div className="container price-block__inner">
                <div className="price-block__top" data-aos="fade-up">
                    <h2 className="price-block__title">Pick your trading account!</h2>
                </div>

                <div className="price-block__grid">
                    {TIERS.map((tier) => (
                        <article key={tier.key} className={`card ${tier.featured ? 'card--featured' : ''}`} >
                            <div className="card__surface">
                                <header className="card__head">
                                    <h3 className="card__title">{tier.name}</h3>
                                </header>

                                <p className="card__tagline">{tier.tagline}</p>

                                <div className="card__price">{tier.price}</div>

                                <ul className="card__list">
                                    {tier.features.map((f, i) => (
                                        <li key={i} className="card__list-item">
                                            <FiCheck className="card__check" aria-hidden />
                                            <span>{f}</span>
                                        </li>
                                    ))}
                                </ul>

                                <a
                                    href={tier.ctaHref}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="card__cta"
                                >
                                    Open account
                                </a>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
